{
	"name": "@melonjs/tiled-inflate-plugin",
	"version": "1.2.1",
	"description": "a melonJS plugin to enable loading and parsing of compressed Tiled maps",
	"homepage": "https://www.npmjs.com/package/@melonjs/tiled-inflate-plugin",
	"type": "module",
	"keywords": [
		"2D",
		"HTML5",
		"javascript",
		"TypeScript",
		"es6",
		"melonjs",
		"Tiled",
		"plugin",
		"gzip",
		"zlib"
	],
	"repository": {
		"type": "git",
		"url": "git+https://github.com/melonjs/melonJS.git",
		"directory": "packages/tiled-inflate-plugin"
	},
	"bugs": {
		"url": "https://github.com/melonjs/melonJS/issues"
	},
	"license": "MIT",
	"author": "Olivier Biot (AltByte Pte Ltd)",
	"funding": "https://github.com/sponsors/melonjs",
	"engines": {
		"node": ">=24.0.0"
	},
	"types": "./build/index.d.ts",
	"exports": {
		".": "./build/index.js"
	},
	"files": [
		"build/",
		"package.json",
		"README.md",
		"LICENSE"
	],
	"peerDependencies": {
		"melonjs": ">=15.2.1"
	},
	"dependencies": {
		"fzstd": "^0.1.1",
		"js-base64": "^3.9.1",
		"pako": "^2.1.0"
	},
	"devDependencies": {
		"esbuild": "^0.27.4",
		"melonjs": "workspace:*",
		"tsconfig": "workspace:*",
		"tsx": "^4.23.1",
		"typescript": "^6.0.2"
	},
	"scripts": {
		"build": "tsx scripts/build.ts && pnpm types",
		"prepublishOnly": "pnpm clean && pnpm build",
		"clean": "tsx scripts/clean.ts",
		"types": "tsc --project tsconfig.build.json"
	}
}
